import {
  CREATE_TPW_SUCCESS,
  FETCH_ACTIVITY_SNO_SUCCESS,
  FETCH_TPW_SUCCESS,
  GET_TPW_SUCCESS,
  SAVE_TPW_QUERY,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  activitySno : '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_TPW_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_TPW_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;
      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_TPW_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_TPW_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_ACTIVITY_SNO_SUCCESS: {
      return {
        ...state,
        activitySno: action.data,
      }
    }
    default:
      return state;
  }
}
